// Module
var code = "<div class=\"page-settings-notification\"> <div class=\"title-buttons\"> <ap-button id=\"save\" type=\"save\"></ap-button> </div> <div class=\"content-settings\"> <form id=\"content_form\"> </form> </div> </div>";
// Exports
export default code;